import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#B09DF9';

export const CastSecurity = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      fill="none"
      viewBox="0 0 25 27"
    >
      <>
        <path
          d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6272 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58204 5.59279C0.6042 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602213 20.8428 1.58204 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
          fill={fill}
        />
        <mask
          id="mask0_18652_2091"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="27"
        >
          <path
            d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6272 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58204 5.59279C0.6042 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602213 20.8428 1.58204 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
            fill={color}
          />
        </mask>
        <g mask="url(#mask0_18652_2091)">
          <path
            d="M7.42285 12.5669L12.1153 15.2778L24.5 8"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
          />
          <path
            d="M19.7877 13.6065C19.7877 16.4307 18.2812 19.0383 15.8366 20.4514L12.4638 22.3991C12.2492 22.5224 11.9848 22.5224 11.7702 22.3991L8.39741 20.4514C5.9528 19.0403 4.44629 16.4307 4.44629 13.6065V9.19427L12.118 4.76416L19.7877 9.19427L19.808 9.87054L19.8284 10.5468"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
          />
        </g>
      </>
    </IconBase>
  );
};

CastSecurity.displayName = 'CastSecurity';
